import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_serialnumber_by_serialnumberIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { serialnumberId: number }): 
  Promise<{ result: { Id?: number, StatusId?: number, HardAllocations?: { Id?: number, Task?: { Id?: number, Order?: { Id?: number, LookupCode?: string } } }[] } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.serialnumberId)) {
      $missingRequiredInParams.push('\'serialnumberId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      serialnumberId: number    }) {
        if(isNil($inParams.serialnumberId)) {
          return true; 
        }
      return false;
    }
}
